"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class MenuApi {
    constructor(api) {
        this.api = api;
    }
    //* -------------------------------------------------------------------------- */
    //*                                     Set                                    */
    //* -------------------------------------------------------------------------- */
    /**
     * 取得套餐(殼)列表
     */
    getCategorySets(merchantId, categoryId, query, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/set";
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const params = Object.assign({ merchantID: merchantId, categoryID: categoryId, takeaway: null }, query);
            const response = yield this.api.axiosGo.get(endpoint, {
                headers,
                params,
            });
            return response.data;
        });
    }
    /**
     * 取得套餐(殼)
     */
    getSet(id, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/info/${id}`;
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const response = yield this.api.axiosGo.get(endpoint, { headers });
            return response.data;
        });
    }
    /**
     * 取得售完的套餐(殼)列表
     * @deprecated 目前沒有專案使用
     */
    getSoldOutSets() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/set";
            const params = { soldOut: true };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 取得推薦套餐(殼)列表
     */
    getPromotedSets() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/set";
            const params = { promoted: true };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 新增套餐(殼)
     */
    createSet(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/set";
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改套餐(殼)
     */
    updateSet(setId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/info`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改套餐(殼)價錢
     * ! 改的是 prices 欄位
     * ! 混淆命名，應改成 updateSetPrices
     */
    updateSetTakeawayPrice(setId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/price`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改套餐(殼)圖片
     */
    updateSetImage(setId, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/image`;
            const data = new FormData();
            data.append("file", file);
            const config = { headers: { "Content-Type": "multipart/form-data" } };
            const response = yield this.api.axiosGo.post(endpoint, data, config);
            return response.data;
        });
    }
    /**
     * 刪除套餐(殼)圖片
     */
    deleteSetImage(setId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/image`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    /**
     * 刪除/隱藏套餐(殼)
     * permanent: true 刪除
     * permanent: false 隱藏，與顯示套餐(殼)對映
     */
    deleteSet(setId, permanent = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}`;
            const data = { params: { perm: permanent } };
            yield this.api.axiosGo.delete(endpoint, data);
        });
    }
    /**
     * 顯示套餐(殼)
     * 與隱藏套餐(殼)對映
     */
    revealSet(setId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/reveal`;
            yield this.api.axiosGo.put(endpoint);
        });
    }
    /**
     * 設定套餐(殼)已售完
     * 與設定套餐(殼)有貨對映
     */
    updateSetSold(setId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/sold`;
            const response = yield this.api.axiosGo.put(endpoint);
            return response.data;
        });
    }
    /**
     * 設定套餐(殼)有貨
     * 與設定套餐(殼)已售完對映
     */
    updateSetStock(setId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/stock`;
            const response = yield this.api.axiosGo.put(endpoint);
            return response.data;
        });
    }
    /**
     * ! 跟上面的不同？
     */
    updateSetsStock(setIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/sets/stock";
            const data = { setIds };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * ! 跟上面的不同？
     */
    updateSetsSold(setIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/sets/sold";
            const data = { setIds };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改允許套餐(殼)外賣 (開啟/關閉)
     * @deprecated 目前沒有專案使用
     */
    updateSetTakeawayEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/set/takeaway";
            const data = { enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     *修改允許套餐(殼)堂食 (開啟/關閉)
     *@deprecated 目前沒有專案使用
     */
    updateSetNonTakeawayEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/set/nontakeaway";
            const data = { enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                  Set Step                                  */
    //* -------------------------------------------------------------------------- */
    /**
     * 新增套餐(殼)步驟
     */
    addSetStep(setId, step) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/step`;
            const response = yield this.api.axiosGo.post(endpoint, step);
            return response.data;
        });
    }
    /**
     * 修改套餐(殼)步驟
     */
    updateSetStep(setId, step) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/step/${step.key}`;
            const response = yield this.api.axiosGo.post(endpoint, step);
            return response.data;
        });
    }
    /**
     * 刪除套餐(殼)步驟
     */
    deleteSetStep(setId, stepKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/step/${stepKey}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    /**
     * 修改套餐(殼)步驟排序
     */
    updateSetStepOrder(setId, stepKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/sortstep`;
            const data = { keys: stepKeys };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                  Set Menu                                  */
    //* -------------------------------------------------------------------------- */
    /**
     * 取得套餐(舊)列表
     */
    getSetMenus(merchantId, setId, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/setmenu";
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const params = { merchantID: merchantId, setID: setId, takeaway: null };
            const response = yield this.api.axiosGo.get(endpoint, {
                headers,
                params,
            });
            return response.data;
        });
    }
    /**
     * 取得推薦的套餐(殼)餐點列表
     * @deprecated 目前沒有專案使用
     */
    getPromotedSetMenus() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/setmenu";
            const params = { promoted: true };
            const response = yield this.api.axiosGo.get(endpoint, {
                params,
            });
            return response.data;
        });
    }
    /**
     * 新增套餐(殼)餐點
     */
    addSetMenu(setId, step, menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/setmenu";
            const data = { setID: setId, step: step, menuID: menuId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改套餐(殼)餐點
     */
    updateSetMenu(setId, setMenuId, setMenu) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/setmenu/${setMenuId}/info`;
            const data = Object.assign(Object.assign({}, setMenu), { setID: setId, categoryID: setMenu.categoryId });
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改套餐(殼)餐點價格
     * ! 改的是 prices 欄位
     */
    updateSetMenuPrice(setMenuId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/setmenu/${setMenuId}/price`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除套餐(殼)餐點
     */
    deleteSetMenu(setMenuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/setmenu/${setMenuId}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
    /**
     * 隱藏套餐(殼)餐點
     */
    updateSetMenuEnable(id, enable) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/setmenu/${id}/enable`;
            const response = yield this.api.axiosGo.post(endpoint, { enable });
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 Set Option                                 */
    //* -------------------------------------------------------------------------- */
    /**
     * 新增選項群
     */
    createSetOptionGroup(setId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    /**
     * 修改選項群
     */
    updateSetOptionGroup(setId, groupId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    /**
     * 刪除選項群
     */
    deleteSetOptionGroup(setId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    /**
     * 新增選項
     */
    createSetOption(setId, groupId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}/opt`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    /**
     * 修改選項
     */
    updateSetOption(setId, groupId, optionId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    /**
     * 刪除選項
     */
    deleteSetOption(setId, groupId, optionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                    Menu                                    */
    //* -------------------------------------------------------------------------- */
    /**
     * 取得餐點列表
     */
    getCategoryMenus(merchantId, categoryId, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menu";
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const params = {
                merchantID: merchantId,
                categoryID: categoryId,
                takeaway: null,
            };
            const response = yield this.api.axiosGo.get(endpoint, {
                headers,
                params,
            });
            return response.data;
        });
    }
    /**
     * 取得餐點
     * @deprecated 目前沒有專案使用
     */
    getMenu(id, setting = false, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/info/${id}`;
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const params = { setting };
            const response = yield this.api.axiosGo.get(endpoint, {
                headers,
                params,
            });
            return response.data;
        });
    }
    /**
     * 取得售完餐點列表
     */
    getSoldOutMenus() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menu";
            const params = { soldOut: true };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 取得推薦餐點列表
     */
    getPromotedMenus() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menu";
            const params = { promoted: true };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 新增餐點
     * 要另外再 call updateMenuTakeawayPrice, updateMenuTakeawayEnable 和 updateMenuNonTakeawayEnable
     */
    createMenu(menu) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menu";
            const response = yield this.api.axiosGo.post(endpoint, menu);
            return response.data;
        });
    }
    /**
     * 刪除/隱藏餐點
     * permanent: true 刪除
     * permanent: false 隱藏，與顯示餐點對映
     */
    deleteMenu(menuId, permanent = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}`;
            const data = { params: { perm: permanent } };
            yield this.api.axiosGo.delete(endpoint, data);
        });
    }
    /**
     * 顯示餐點
     * 與隱藏餐點對映
     */
    revealMenu(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/reveal`;
            yield this.api.axiosGo.put(endpoint);
        });
    }
    /**
     * 設定餐點已售完
     * 與設定餐點有貨對映
     */
    setMenuSold(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/sold`;
            const response = yield this.api.axiosGo.put(endpoint);
            return response.data;
        });
    }
    /**
     * 設定餐點有貨
     * 與設定餐點已售完對映
     */
    setMenuStock(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/stock`;
            const response = yield this.api.axiosGo.put(endpoint);
            return response.data;
        });
    }
    /**
     * ! 跟上面的不同？
     */
    updateMenusStock(menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menus/stock";
            const data = { menuIds };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * ! 跟上面的不同？
     */
    updateMenusSold(menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menus/sold";
            const data = { menuIds };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改餐點
     */
    updateMenu(menuId, menu) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/info`;
            const response = yield this.api.axiosGo.post(endpoint, menu);
            return response.data;
        });
    }
    /**
     * 修改餐點圖片
     */
    updateMenuImage(menuId, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/image`;
            const data = new FormData();
            data.append("file", file);
            const config = { headers: { "Content-Type": "multipart/form-data" } };
            const response = yield this.api.axiosGo.post(endpoint, data, config);
            return response.data;
        });
    }
    /**
     * 刪除餐點圖片
     */
    deleteMenuImage(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/image`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    /**
     * 修改餐點價格
     * ! 改的是 prices 欄位
     * ! 混淆命名，應改成 updateMenuPrices
     */
    updateMenuTakeawayPrice(menuId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/price`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改允許餐點外賣 (開啟/關閉)
     */
    updateMenuTakeawayEnable(menuId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/takeaway`;
            const data = { enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改允許餐點堂食 (開啟/關閉)
     */
    updateMenuNonTakeawayEnable(menuId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/nontakeaway`;
            const data = { enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * ! need API documentation
     */
    updateMenuDepartment(menuId, kitchenDepartmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.put(`/m/menu/${menuId}/kitchendepartment`, { kitchenDepartmentId });
            return response.data;
        });
    }
    updateMenuOrderItemLimit(menuId, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.put(`/m/menu/${menuId}/orderitemlimit`, { value });
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                 Menu Option                                */
    //* -------------------------------------------------------------------------- */
    /**
     * 新增選項群
     */
    createMenuOptionGroup(menuId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    /**
     * 修改選項群
     */
    updateMenuOptionGroup(menuId, groupId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    /**
     * 刪除選項群
     */
    deleteMenuOptionGroup(menuId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    /**
     * 新增選項
     */
    createMenuOption(menuId, groupId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}/opt`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    /**
     * 修改選項
     */
    updateMenuOption(menuId, groupId, optionId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    /**
     * 刪除選項
     */
    deleteMenuOption(menuId, groupId, optionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                             Option Group Preset                            */
    //* -------------------------------------------------------------------------- */
    /**
     * 修改預設選項群
     * ! need API documentation
     */
    updateMenuOptionGroupPresets(menuId, optionGroupPresets, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/optiongrouppreset`;
            const data = { optionGroupPresets, locale };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     * ! need API documentation
     */
    getOptionGroupPresets(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/optiongrouppreset";
            const headers = {
                "Accept-Language": locale != null ? locale : this.api.locale,
            };
            const params = { locale: locale != null ? locale : this.api.locale };
            const response = yield this.api.axiosGo.get(endpoint, {
                headers,
                params,
            });
            return response.data;
        });
    }
    /**
     * 新增預設選項群
     * ! need API documentation
     */
    createOptionGroupPreset(optionGroupPreset) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/optiongrouppreset";
            const response = yield this.api.axiosGo.post(endpoint, optionGroupPreset);
            return response.data;
        });
    }
    /**
     * 修改預設選項群
     * ! need API documentation
     */
    updateOptionGroupPreset(optionGroupPreset) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/optiongrouppreset/${optionGroupPreset.id}`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroupPreset);
            return response.data;
        });
    }
    /**
     * 刪除預設選項群
     * ! need API documentation
     */
    deleteOptionGroupPreset(optionGroupPresetId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/optiongrouppreset/${optionGroupPresetId}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
    /**
     * ! need API documentation
     */
    setOptionGroupPreset(optionGroupPreset, menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menus/optiongrouppreset";
            const data = { optionGroupPreset, menuIds };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * ! need API documentation
     */
    deleteMenuOptionGroupPreset(optionGroupPresetId, menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menus/optiongrouppreset/${optionGroupPresetId}`;
            const data = { data: { menuIds } }; // ! 看起來很奇怪？
            const response = yield this.api.axiosGo.delete(endpoint, data);
            return response.data;
        });
    }
    //* -------------------------------------------------------------------------- */
    //*                                     ？？？                                    */
    //* -------------------------------------------------------------------------- */
    /**
     * ! need API documentation
     */
    getAllMenus(merchantId, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            // 菜單較多的餐廳會需要很久的時間（例如：Ben1 館需要 34 秒），因此設定 timeout 1 分鐘
            const response = yield this.api.axiosGo.get("/m/menus/listall", {
                params: {
                    merchantId,
                },
                timeout: timeout || 60000,
            });
            return response.data;
        });
    }
    /**
     * ! need API documentation
     */
    updateMenuTag(menuId, tag) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/tag`;
            const response = yield this.api.axiosGo.post(endpoint, tag);
            return response.data;
        });
    }
    /**
     * ! need API documentation
     */
    updateInventory(menuIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = "/m/menus/inventory";
            const response = yield this.api.axiosGo.put(endpoint, menuIds);
            return response.data;
        });
    }
}
exports.default = MenuApi;
//# sourceMappingURL=Menu.js.map